// Tracks which vehicles have declined a given booking, so the auto-reassign
// flow (TC-09) never offers the same job back to a vehicle that rejected it.
//
// NOTE: this is browser-local. It reliably prevents a vehicle from being
// re-offered a job it already declined *in this browser session*. Propagating
// the full decline history across different drivers' devices requires the
// backend to persist it on the booking record.

const STORAGE_KEY = "declined_vehicles_by_booking";
const MAX_BOOKINGS = 50;

const readAll = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

const writeAll = (map) => {
  try {
    // keep the store from growing without bound
    const entries = Object.entries(map);
    const trimmed = entries.length > MAX_BOOKINGS
      ? Object.fromEntries(entries.slice(-MAX_BOOKINGS))
      : map;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
  } catch {
    // storage full / unavailable — exclusion just falls back to in-request only
  }
};

export const getDeclinedVehicles = (bId) => {
  if (!bId) return [];
  const list = readAll()[String(bId)];
  return Array.isArray(list) ? list : [];
};

export const addDeclinedVehicle = (bId, vehicleId) => {
  if (!bId || !vehicleId) return getDeclinedVehicles(bId);
  const all = readAll();
  const key = String(bId);
  const existing = Array.isArray(all[key]) ? all[key] : [];
  const next = Array.from(new Set([...existing, String(vehicleId).trim()]));
  all[key] = next;
  writeAll(all);
  return next;
};

export const clearDeclinedVehicles = (bId) => {
  if (!bId) return;
  const all = readAll();
  delete all[String(bId)];
  writeAll(all);
};
